module.exports = __webpack_public_path__ + "img/fef5644.png";